<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, useTemplateRef } from "vue";
import BaseEditor from "./BaseEditor.vue";
import { getSiteData } from "@/NavigationHelper";
import { mountedBase, onSave, BaseSetup, onDelete } from "@/DataLoaderStatic";

const emit = defineEmits(["back"]);

const editor = useTemplateRef<InstanceType<typeof BaseEditor>>("editor");
const currentEditorData = ref<any>(null);

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => {
    emit("back");
  },
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

let siteData: any;

onMounted(async () => {
  siteData = getSiteData();
  pageParams.query = siteData.query;
  await mountedBase(uiData, pageParams);
  uiData.initialized = true;
});

function editorReady(editorUiData: DataPageUIData) {
  currentEditorData.value = editorUiData;
  siteData.getReturnData = () => {
    const currentData = currentEditorData.value?.data ?? [];

    if (currentData.length > 0) {
      const row = currentData[0];
      Object.keys(row).forEach((key) => {
        console.log(`   ${key}:`, row[key], typeof row[key]);
      });
    }
    return currentData;
  };
}
</script>

<template>
  <v-sheet>
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <BaseEditor
      ref="editor"
      v-if="uiData.initialized"
      :showSaveButton="false"
      :showBackButton="false"
      showBaseButton="false"
      :query="pageParams.query"
      :zeitbereich="pageParams.zeitbereich"
      fieldCssClass="md12 pa-5"
      insertHint="true"
      class="pa-5"
      :preloadedData="pageParams.preloadedData"
      @ready="editorReady"
      :numberOfColumns="12"
    />
  </v-sheet>
</template>
